import { RefObject, useEffect, useState } from "react";
import { Period, Record } from "../../types";
import RecordTable from "./RecordTable";
import ManageRecordForm from "../../components/ManageRecordForm";
import Modal from "../../components/Modal";

interface RecordViewerProps {
  period: Period | null;
  records: Record[];
  loading: boolean;
  handleRemoveRecord: (id: number) => void;
  handleUpdateRecord: (record: Record) => void;
  recordTable: RefObject<HTMLTableElement>;
}

function PeriodViewer({
  period,
  records,
  loading,
  handleRemoveRecord,
  handleUpdateRecord,
  recordTable,
}: RecordViewerProps) {
  let [totalPay, setTotalPay] = useState(0);
  let [totalDays, setTotalDays] = useState(0);
  let [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  let [editRecord, setEditRecord] = useState<Record | null>(null);

  useEffect(() => {
    let t = records.reduce(
      (acc, pay_event: Record) => acc + pay_event.amount,
      0,
    );
    setTotalDays(t);
    setTotalPay(t * 93.96);
  }, [records]);

  function handleEdit(index: number) {
    setEditRecord(records[index]);
    setEditModalOpen(true);
  }

  async function handleSaveEdit(record: Record) {
    await handleUpdateRecord(record);
    setEditModalOpen(false);
    setEditRecord(null);
  }

  return (
    <>
      <section
        className="bg-grayscale-800 shadow-grayscale-800 w-full flex-grow rounded-lg p-3  lg:order-2"
        id="current-period"
      >
        <h2 className="mb-2 text-center font-semibold">{period?.name}</h2>
        <h3 className="text-blu-200 mb-2 text-center">
          {period?.start_date} to {period?.end_date ? period.end_date : "now"}
        </h3>
        {period ? (
          <>
            <div className="mb-2 flex justify-between">
              <p>
                Total RSDs:{" "}
                {!loading ? (
                  <span className="text-blu-200 font-semibold">
                    {totalDays}
                  </span>
                ) : (
                  <></>
                )}
              </p>
              <p>
                Net Pay:{" "}
                {!loading ? (
                  <span className="text-blu-200 font-semibold">
                    £{totalPay.toFixed(2)}
                  </span>
                ) : (
                  <></>
                )}
              </p>
            </div>
            <RecordTable
              records={records}
              loading={loading}
              removeRecord={handleRemoveRecord}
              handleEdit={handleEdit}
              recordTable={recordTable}
            />
            {editModalOpen && editRecord ? (
              <Modal
                open={editModalOpen}
                closeModal={() => {
                  setEditModalOpen(false);
                  setEditRecord(null);
                }}
              >
                <section className="bg-grayscale-900 shadow-grayscale-900 w-full rounded-lg p-3 shadow lg:order-3 lg:w-auto">
                  <h2 className="w-auto shrink text-center font-semibold">
                    Edit Record
                  </h2>
                  <ManageRecordForm
                    handleSubmit={handleSaveEdit}
                    period={period}
                    record={editRecord}
                    records={records}
                  />
                </section>
              </Modal>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </section>
    </>
  );
}

export default PeriodViewer;
